class LocalStorageService {
    setUserPersonCode = async (usrPersonCode: string) => {
        localStorage.setItem("userPersonCode", usrPersonCode)
    }
    getUserPersonCode = () => {
        return localStorage.getItem("userPersonCode");
    }
}

export default new LocalStorageService();